/**
 * @file src/pages/refunds/components/LoadingSkeleton.jsx
 * @description Loading placeholder shown while refunds + credit notes
 * queries are in flight. Matches the layout of the real page so the
 * transition feels less jarring.
 */

import React from "react";

const LoadingSkeleton = ({ isCollapsed }) => (
  <div
    className={`transition-all duration-300 ${
      isCollapsed ? "md:ms-16" : "md:ms-64"
    }`}
  >
    <main className="p-4 md:p-6 animate-pulse">
      {/* Header */}
      <div className="h-8 bg-muted rounded w-64 mb-2" />
      <div className="h-4 bg-muted rounded w-96 mb-8" />

      {/* Stats row */}
      <div className="grid grid-cols-4 gap-4 mb-6">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="h-20 bg-muted rounded-xl" />
        ))}
      </div>

      {/* Tabs */}
      <div className="h-12 bg-muted rounded-xl w-64 mb-6" />

      {/* Search */}
      <div className="h-14 bg-muted rounded-xl mb-6" />

      {/* Table */}
      <div className="bg-card rounded-xl border border-border p-6 space-y-3">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="h-14 bg-muted rounded" />
        ))}
      </div>
    </main>
  </div>
);

export default LoadingSkeleton;
